module.exports = require('./helpers/bundle-url').getBundleURL('aoipb') + "logo.c51670a8.svg";